export default __webpack_public_path__ + "static/media/template6.1e6e3ac3.svg";